 
import { key } from 'localforage';
import WebOffice from '../../../webOffice/index';   

export default{
    components:{//自定义组件列表 
        'web-office':WebOffice,  

	},
    data() {
        return {
            breadcrumb:[{
                name:'首页', path:'/home'
            },{
                name:'发文列表', path:''
            },{
                name:'发文详情', path:''
            }],
           
            apis:{//接口列表 
                upload: this.$global.baseUrl + 'sh/file/upload',//文件上传   
                save:'oa/official/sendDoc/save',//保存
                bykey:'oa/official/sendDoc/byKey',//详情
                fileNumList:'oa/fn/cfg/list', //文号配置列表
                getFileNum:'oa/fn/cfg/getFileNum',
                getWfTask:'/oa/official/getWFTask',//任务详情
                sign: 'sh/wf/task/sign', //签收任务 
                histotyFile:'oa/official/sendDoc/historyFile',
                downloadFileAll:'oa/official/downloadFileAll',
                del: 'oa/official/sendDoc/del',//删除
            }, 
            editObj:{
                title:"",
                fileKey:""
            },
            wfFlowModel:{
                finish:false,
                turn:false,
            },
            key:"", 
            fileList:[],//源文件 
            userWnd: false,//是否显示人员选择窗口
            rules:{ 
                title:[{ required: true, message: '请输入标题', trigger: 'blur' }],
                fileNumStr:[{ required: true, message: '请输入文号', trigger: 'blur' }],
                category:[{ required: true, message: '请选择文档归类', trigger: 'change' }], 
                fileNumCfgKey:[{ required: true, message: '请选择文号设置', trigger: 'change' }],
                majorOrg:[{ required: true, message: '请输入主送单位', trigger: 'blur' }],
            },
            fileNumList:[],
            webShow: false,
            fileLists: [],
            WFtask:{}, 
            docFileKey:'',
            fileType:".docx",
            drawer:false,
            historyFile:[],
            drawerFile:false
        }
    },
    props: {
        visible: { 
          type: Boolean,
          default: false
        }, 
        bizKey:String,
        taskKey:String, 
    },
    watch: {
        bizKey() {
            this.init();
        }, 
    }, 
    mounted() {  
        this.init(); 
    },                     
    methods: {
        init(){  
            this.key = this.bizKey;
            let taskKey = this.taskKey;
            if (this.key > -1) {
                this.find();
            }
            if (taskKey > -1) {
                this.getWfTask(taskKey);
            }
        },
        getWfTask(taskKey){  
            this.$post({
                url: this.apis.getWfTask,
                params:taskKey,  
            }).then(rsp => {
                if(rsp.success){
                    this.WFtask = rsp.retObj; 
                    if(this.WFtask.type==2){
                        this.sign();
                    }
                }
            })
        },
        sign(){
            const me = this;
            me.$post({
                url: me.apis.sign,
                params: me.WFtask.id
            }).then(rsp => {
                if(rsp.success){ 
                    me.$message.success("签收成功");
                }
            })
        },
        find(){
            const me = this; 
            me.fileLists=[];
            me.$post({
                url: me.apis.bykey,
                params:me.key
            }).then(rsp => {
                if(rsp.success){
                    me.editObj = rsp.retObj;
                    me.fileLists = rsp.retObj.officialFiles;
                    me.$delete(me.editObj, 'officialFiles');
                }
            })
        }, 
        goBack(){ 
            this.$router.go(-1);
        },  
        callback(fileKey){
            this.webShow=false;
            this.$set(this.editObj,"fileKey",fileKey); 
            console.log(this.editObj.fileKey);
        },
        editDoc(){
            // this.docFileKey=this.editObj.fileKey;
            // this.fileType=".docx";
            // this.webShow=true;
            let {href}  = this.$router.resolve({ 
                path: "/oa/office/browerDialog",
                query:{
                    isView:1,
                    bizKey:this.key,
                    fileType:".docx",
                    bizType:1,
                    fileId:this.editObj.fileKey 
                }
            })    
            this.winDialog=window.open(href,"_blank"," left=0,top=0,width="+ (screen.availWidth - 10) +",height="+ (screen.availHeight-50) +",toolbar=no, menubar=no, scrollbars=no,location=no, status=no");
        },
        handlePreview(file) { 
            if (file.kindType == 1) {
                this.$emit('changeBiz',file.docKey,1); 
            } else if (file.kindType == 2) {
                this.$emit('changeBiz',file.docKey,2);
            } else if (file.kindType == 3) {
                this.$emit('changeBiz',file.docKey,3);
            } else if (file.kindType == 4) {
                this.$emit('changeBiz',file.docKey,4);
            } else {
                if (file.filePath.includes(".docx") || file.filePath.includes(".xlsx") || file.filePath.includes(".doc") || file.filePath.includes(".xls")) {
                    // this.isView = 1;
                    // this.docFileKey = file.fileKey;
                    // this.fileType = file.filePath.substring(file.filePath.lastIndexOf("."), file.filePath.length);
                    // this.webShow = true;
                    let {href}  = this.$router.resolve({ 
                        path: "/oa/office/browerDialog",
                        query:{
                            isView:1,
                            bizKey:this.key,
                            fileType:file.filePath.substring(file.filePath.lastIndexOf("."), file.filePath.length),
                            bizType:1,
                            fileId:file.fileKey 
                        }
                    })    
                    this.winDialog=window.open(href,"_blank"," left=0,top=0,width="+ (screen.availWidth - 10) +",height="+ (screen.availHeight-50) +",toolbar=no, menubar=no, scrollbars=no,location=no, status=no");
                }else if(file.filePath.includes(".txt") ||file.filePath.includes(".pdf") || file.filePath.includes(".PDF") || file.filePath.includes(".png") || file.filePath.includes(".PNG")|| file.filePath.includes(".jgp") || file.filePath.includes(".JPG")|| file.filePath.includes(".gif") || file.filePath.includes(".GIF")){
                    const url = this.$global.baseUrl + file.filePath;
                    window.open(url, '_blank');
                }  
                else {
                    const url = this.$global.baseUrl + 'sh/file/download?id=' + file.fileKey;
                    window.open(url, '_blank');
                }
            } 
        },
        close(){
            if(this.bizKey!=this.key){
                this.key=this.bizKey;
                this.find();
            }else{
                this.$emit('close'); 
            }
        },
        print(){
            let {href}  = this.$router.resolve({ path: '/oa/official/sendDoc/print/'+this.key })
            window.open(href, '_blank') 
        },
        showDrawer(){
            this.historyFile=[];
            this.$post({
                url: this.apis.histotyFile,
                params:this.key
            }).then(rsp => {
                if(rsp.success){ 
                    this.historyFile=rsp.retObj;
                    this.drawer=true;
                }
            })
        },

        download(row){
            const url = this.$global.baseUrl + row.path;
            window.open(url, '_blank');
        },
        getReadPower(v){ 
            if(v==1){
                return "会员";
            }else if(v==2){
                return "游客";
            }else{ 
                return "禁止查看";
            }
        },
        downloadFile(row){
            if(row.fileKey){
                const url = this.$global.baseUrl + 'sh/file/download?id=' + row.fileKey;
                window.open(url, '_blank');
            }else{
                this.$message.error("该公文未编辑文件,请检查!");
                return;
            }
        },
        downloadAll(){
            const url = this.$global.baseUrl + this.apis.downloadFileAll+"?bizKey=" + this.key;
            window.open(url, '_blank');
           
        },  
    },
}


// WEBPACK FOOTER //
// ./src/components/oa/view/official/sendDoc/view/view.js